var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutList",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("h1", [_vm._v("Members")]),
          _vm._v(" "),
          _vm.can("createMembers")
            ? _c(
                "router-link",
                {
                  staticClass: "btn btn--primary",
                  attrs: { to: "/members/create" },
                },
                [_vm._v("\n                Member Setup\n            ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "filters" },
        [
          _c("FormControlCountry", {
            attrs: {
              name: "member",
              placeholder: "Select...",
              label: "Country",
            },
            model: {
              value: _vm.filters.country,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "country", $$v)
              },
              expression: "filters.country",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("GridMembers", { attrs: { filters: _vm.filters } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }